<template lang="pug">
  .settings
      v-container.white.pa-0(style="max-width:600px" v-if="member && member.role === 'Admin'")

        v-card(flat :outlined="$vuetify.breakpoint.smAndDown ? false : true" :class="$vuetify.breakpoint.smAndDown ? '' : 'mt-5'")
          //- orga setting
          .general
            v-row.pa-4(no-gutters @click="$router.push('/admin/donation/settings/general')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="settings-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('general') }}
                  .c1.basic600--text {{ $t('general_details') }}
            v-divider.basic300
          
          //- payment settings
          v-row.pa-4(no-gutters @click="$router.push('/admin/donation/settings/payment')" style="cursor: pointer")
            v-col.shrink()
              eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-col.pl-4
              div.my-auto
                .s1.basic800--text {{ $t('payment') }}
                .c1.basic600--text {{ $t('payment_gateway_details') }}
          v-divider.basic300

          //- marketing settings 
          v-row.pa-4(no-gutters @click="$router.push('/admin/donation/settings/marketing-tracking')" style="cursor: pointer")
            v-col.shrink()
              eva-icon.ma-auto(name="pie-chart-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-col.pl-4
              div.my-auto
                .s1.basic800--text {{ $t('pixel') }}
                .c1.basic600--text {{ $t('analytics_description') }}
          v-divider.basic300

          //- integration settings
          v-row.pa-4(no-gutters @click="$router.push('/admin/donation/settings/integration')" style="cursor: pointer")
            v-col.shrink()
              eva-icon.ma-auto(name="globe-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-col.pl-4
              div.my-auto
                .s1.basic800--text {{ $t('integration') }}
                .c1.basic600--text {{ $t('integration_details') }}
          v-divider.basic300

          //- Subscription
          //- .subscription(v-if="member && member.id === company.primary_owner")
            v-row.pa-4(no-gutters @click="$router.push('/admin/donation/settings/subscription')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="hard-drive-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('subscription') }}
                  .c1.basic600--text {{ $t('subscription_details') }}
            v-divider.basic300
          //- Bills
          .bills(v-if="member && member.id === company.primary_owner")
            v-row.pa-4(no-gutters @click="$router.push('/admin/donation/settings/bills')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="file-text-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('bills') }}
                  .c1.basic600--text {{ $t('bills_details') }}
            v-divider.basic300
          //- Account settings
          v-row.pa-4(no-gutters @click="$router.push('/admin/donation/settings/account')" style="cursor: pointer")
            v-col.shrink()
              eva-icon.ma-auto(name="person-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-col.pl-4
              div.my-auto
                .s1.basic800--text {{ $t('account') }}
                .c1.basic600--text {{ $t('account_details') }}
          v-divider.basic300
          //- Delete
          .delete(v-if="member && member.role === 'Admin'")
            v-row.pa-4(no-gutters @click="deleteCompanyDialog = !deleteCompanyDialog" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="trash-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('delete') }}
                  .c1.basic600--text {{ $t('delete_details') }}
            v-divider.basic300

      .modals
        delete-company(v-if="deleteCompanyDialog" :open.sync="deleteCompanyDialog" :company="company")

</template>

<script>
import { mapState } from 'vuex'
import DeleteCompany from '@/components/dialogs/settings/DeleteCompany.vue'

export default {
  name: 'Settings',
  components: { DeleteCompany },
  props: ['company'],
  data () {
    return {
      showSubscribeModal: false,
      deleteCompanyDialog: false,
    }
  },
  computed: {
    ...mapState('user', ['member'])
  }
}
</script>

<i18n>
{
  "en": {
    "general": "General",
    "pixel": "Pixel",
    "general_details": "Organization name, address, registration number",
    "account": "Account settings",
    "account_details": "Avatar, name, language, sign in methods, payment card",
    "notifications": "Notifications",
    "notifications_details": "Email and Application notifications",
    "books": "Yezza Books Settings",
    "books_details": "Accounting, customization, import and export data",
    "subscription": "Subscription",
    "subscription_details": "Current plan, next billing",
    "bills": "Bills",
    "bills_details": "List of previous bills",
    "zoo": "Zoo App",
    "zoo_details": "Zoo apps settings",
    "delete": "Delete Organization",
    "delete_details": "Stop using Yezza Donation OS"
  },
  "id": {
    "general": "General",
    "pixel": "Pixel",
    "general_details": "Nama Perusahaan, Alamat, Nomor Registrasi",
    "account": "Pengaturan Akun",
    "account_details": "Avatar, Nama, Bahasa, Metode sign in, Kartu pembayaran",
    "notifications": "Notifikasi",
    "notifications_details": "Email and Notifikasi Aplikasi",
    "books": "Pengaturan Yezza Books",
    "books_details": "Akuntansi, penyesuaian, impor dan ekspor data",
    "subscription": "Berlangganan",
    "subscription_details": "Paket saat ini, tagihan berikutnya",
    "bills": "Tagihan",
    "bills_details": "Daftar tagihan sebelumnya",
    "zoo": "Zoo App",
    "zoo_details": "Pengaturan Zoo App",
    "delete": "Pengaturan Hapus Akun",
    "delete_details": "Hapus Akun Perusahaan dari Yezza"
  }
}
</i18n>